import { render, staticRenderFns } from "./BuildingMap.vue?vue&type=template&id=56485c5a"
import script from "./BuildingMap.vue?vue&type=script&lang=js"
export * from "./BuildingMap.vue?vue&type=script&lang=js"
import style0 from "./BuildingMap.vue?vue&type=style&index=0&id=56485c5a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports